import * as React from 'react';
import { Page, Subscriber } from 'resources/types';
import Confirm from 'components/confirm';

interface ConfirmationModalProps {
  page: Page;
  subscriber: Subscriber;
  onConfirm(): void;
}

const UnsubscribeConfirmationModal = ({
  page,
  subscriber,
  onConfirm,
}: ConfirmationModalProps) => (
  <Confirm
    id="confirmationModalId"
    title="Confirm Unsubscribe"
    onConfirm={onConfirm}
    confirm_text="Unsubscribe from updates"
    confirmClass="style-warning"
  >
    <div style={{ padding: '1em' }}>
      Click the confirm button below to unsubscribe{' '}
      <strong>{Subscriber.identifier(subscriber)}</strong> from all{' '}
      <strong>{page.name}</strong> updates.
    </div>
  </Confirm>
);

export default UnsubscribeConfirmationModal;



// WEBPACK FOOTER //
// ./app/javascript/containers/status/manage/unsubscribe_confirmation_modal.tsx